// Loads the Razorpay checkout script on demand and opens the modal.
let _loading = null;

export function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (_loading) return _loading;
  _loading = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
  return _loading;
}

// order: { key_id, rzp_order_id, amount, currency, prefill, test_mode }
// onSuccess receives { razorpay_payment_id, razorpay_order_id, razorpay_signature }
export async function openRazorpay(order, { name, description, onSuccess, onDismiss }) {
  // Test mode (no live keys configured): skip the hosted modal and resolve
  // with a synthetic payment id so the flow is testable end-to-end.
  if (order.test_mode || !order.key_id) {
    onSuccess({
      razorpay_payment_id: `pay_test_${Date.now()}`,
      razorpay_order_id: order.rzp_order_id,
      razorpay_signature: "test",
    });
    return;
  }
  const ok = await loadRazorpay();
  if (!ok) throw new Error("Razorpay failed to load");
  const rzp = new window.Razorpay({
    key: order.key_id,
    amount: order.amount,
    currency: order.currency || "INR",
    name: name || "Squire & Squire",
    description: description || "Bespoke order",
    order_id: order.rzp_order_id,
    prefill: order.prefill || {},
    theme: { color: "#1B2A4A" },
    handler: (resp) => onSuccess(resp),
    modal: { ondismiss: () => onDismiss && onDismiss() },
  });
  rzp.on("payment.failed", () => onDismiss && onDismiss());
  rzp.open();
}
